module.exports = __webpack_public_path__ + "img/step3a.4dd20f90.svg";